/* eslint-disable complexity */
/* eslint-disable import/no-unresolved */
/* eslint-disable object-shorthand */
/* eslint-disable react/function-component-definition */
import '@nosferatu500/react-sortable-tree/style.css';
import './LocationsCategories.scss';

import {
  addNodeUnderParent,
  changeNodeAtPath,
  getNodeAtPath,
  removeNodeAtPath,
  toggleExpandedForAll,
} from '@nosferatu500/react-sortable-tree';
import useGetLocationsTreeData from 'api/locationsCategories/useGetLocationsTreeData';
import ComposeAddressModal from 'components/private/Categories/LocationsCategories/address/ComposeAddressModal';
import DeComposeAddressModal from 'components/private/Categories/LocationsCategories/address/DeComposeAddressModal';
import RecomposeAddressModal from 'components/private/Categories/LocationsCategories/address/RecomposeAddressModal';
import ShowAddressModal from 'components/private/Categories/LocationsCategories/address/ShowAddressModal';
import CreateAreaNodeModal from 'components/private/Categories/LocationsCategories/area/CreateAreaNodeModal';
import EditAreaNodeModal from 'components/private/Categories/LocationsCategories/area/EditAreaNodeModal';
import CreateCellNodeModal from 'components/private/Categories/LocationsCategories/cell/CreateCellNodeModal';
import EditCellNodeModal from 'components/private/Categories/LocationsCategories/cell/EditCellNodeModal';
import DeleteNodeDialog from 'components/private/Categories/LocationsCategories/DeleteNodeDialog';
import CreatePartNodeModal from 'components/private/Categories/LocationsCategories/part/CreatePartNodeModal';
import EditPartNodeModal from 'components/private/Categories/LocationsCategories/part/EditPartNodeModal';
import PrintModal from 'components/private/Categories/LocationsCategories/print/PrintModal';
import CreateSectionNodeModal from 'components/private/Categories/LocationsCategories/section/CreateSectionNodeModal';
import EditSectionNodeModal from 'components/private/Categories/LocationsCategories/section/EditSectionNodeModal';
import CreateShelfNodeModal from 'components/private/Categories/LocationsCategories/shelf/CreateShelfNodeModal';
import EditShelfNodeModal from 'components/private/Categories/LocationsCategories/shelf/EditShelfNodeModal';
import TreeDataBarWrapper from 'components/private/Categories/treeDataBarWrapper/TreeDataBarWrapper';
import TreeDataBodyWrapper from 'components/private/Categories/treeDataBodyWrapper/TreeDataBodyWrapper';
import PageSpinner from 'components/shared/pageSpinner/PageSpinner';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function LocationsCategories() {
  const { guid: zoneGuid } = useParams();

  const [getLoading, treeData, setTreeData, getTreeData] =
    useGetLocationsTreeData();

  const [searchString, setSearchString] = useState('');
  const [searchFocusIndex, setSearchFocusIndex] = useState(0);
  const [searchFoundCount, setSearchFoundCount] = useState(null);

  const [createSectionNodeModal, setCreateSectionNodeModal] = useState({
    show: false,
    guid: null,
    rowInfo: null,
  });
  const [editSectionNodeModal, setEditSectionNodeModal] = useState({
    show: false,
    guid: null,
    title: '',
    rowInfo: null,
  });

  const [createAreaNodeModal, setCreateAreaNodeModal] = useState({
    show: false,
    guid: null,
    rowInfo: null,
  });
  const [editAreaNodeModal, setEditAreaNodeModal] = useState({
    show: false,
    guid: null,
    title: '',
    rowInfo: null,
  });

  const [createShelfNodeModal, setCreateShelfNodeModal] = useState({
    show: false,
    guid: null,
    rowInfo: null,
  });
  const [editShelfNodeModal, setEditShelfNodeModal] = useState({
    show: false,
    guid: null,
    title: '',
    rowInfo: null,
  });

  const [createPartNodeModal, setCreatePartNodeModal] = useState({
    show: false,
    guid: null,
    rowInfo: null,
  });
  const [editPartNodeModal, setEditPartNodeModal] = useState({
    show: false,
    guid: null,
    title: '',
    rowInfo: null,
  });

  const [createCellNodeModal, setCreateCellNodeModal] = useState({
    show: false,
    guid: null,
    rowInfo: null,
  });
  const [editCellNodeModal, setEditCellNodeModal] = useState({
    show: false,
    guid: null,
    title: '',
    rowInfo: null,
  });

  const [composeAddressModal, setComposeAddressModal] = useState({
    show: false,
    guid: null,
    rowInfo: null,
  });
  const [reComposeAddressModal, setReComposeAddressModal] = useState({
    show: false,
    guid: null,
    addressGuid: null,
    rowInfo: null,
  });
  const [deComposeAddressModal, setDeComposeAddressModal] = useState({
    show: false,
    guid: null,
    addressGuid: null,
    rowInfo: null,
  });
  const [showAddressHandler, setShowAddressHandler] = useState({
    show: false,
    guid: null,
    addressGuid: null,
    rowInfo: null,
  });

  const [deleteNodeDialog, setDeleteNodeDialog] = useState({
    show: false,
    guid: null,
    nodeType: '',
    rowInfo: null,
  });

  const [printModal, setPrintModal] = useState({
    show: false,
    rootPrints: false,
    guid: null,
    addressGuid: null,
    type: null,
  });

  useEffect(() => {
    if (!zoneGuid) return;
    getTreeData(zoneGuid);
  }, []);

  const refreshDataAfterCreateNode = (data, rowData) => {
    setTreeData(prevTree => {
      if (rowData?.rowInfo?.path) {
        // 1️⃣ پیدا کردن parent
        const parentNode = getNodeAtPath({
          treeData: prevTree,
          path: rowData?.rowInfo?.path,
          getNodeKey: ({ treeIndex }) => treeIndex,
        });

        const childrenCount = parentNode?.node?.children?.length ?? 0;

        // 1️⃣ اضافه کردن child
        const result = addNodeUnderParent({
          treeData: prevTree,
          parentKey: rowData?.rowInfo?.path[rowData?.rowInfo?.path.length - 1],
          expandParent: true,
          newNode: data,
          getNodeKey: ({ treeIndex }) => treeIndex,
        });

        let treeAfterAdd = result.treeData;

        if (childrenCount === 0) {
          // 2️⃣ تغییر parent
          treeAfterAdd = changeNodeAtPath({
            treeData: treeAfterAdd,
            path: rowData?.rowInfo?.path,
            getNodeKey: ({ treeIndex }) => treeIndex,
            newNode: ({ node }) => ({
              ...node,
              isComposable: false,
              isDeletable: false,
            }),
          });
        }

        return treeAfterAdd;
      } else {
        return [
          ...prevTree,
          {
            ...data,
            isComposable: false,
          },
        ];
      }
    });
  };

  const refreshDataAfterDeleteNode = rowData => {
    const { path } = rowData.rowInfo;
    const parentPath = path.slice(0, -1);

    setTreeData(prevTree => {
      // 1️⃣ آپدیت parent
      const tree1 = changeNodeAtPath({
        treeData: prevTree,
        path: parentPath,
        getNodeKey: ({ treeIndex }) => treeIndex,
        newNode: ({ node }) => {
          const childrenCount = node.children ? node.children.length : 0;

          if (childrenCount === 1) {
            return {
              ...node,
              isDeletable: true,
              isComposable: true,
            };
          }
          return node;
        },
      });
      // 2️⃣ حذف child
      const tree2 = removeNodeAtPath({
        treeData: tree1,
        path: path,
        getNodeKey: ({ treeIndex }) => treeIndex,
      });

      return tree2;
    });
  };

  const refreshDataAfterEditNode = (data, rowData) => {
    const { path } = rowData.rowInfo;
    const { node } = rowData.rowInfo;
    const updatedData = {
      ...node,
      ...data,
      // children: node.children,
    };

    const newTree = changeNodeAtPath({
      treeData: treeData,
      path,
      newNode: updatedData,
      expandParent: true,
      parentKey: rowData.rowInfo ? rowData.rowInfo.treeIndex : undefined,
      getNodeKey: ({ treeIndex }) => treeIndex,
    });
    setTreeData(newTree);
  };

  const refreshDataAfterComposeAddress = (data, rowData) => {
    const { path } = rowData.rowInfo;
    const parentPath = path.slice(0, -1);

    setTreeData(prevTree => {
      // 1️⃣ آپدیت خود child
      const tree1 = changeNodeAtPath({
        treeData: prevTree,
        path: path,
        getNodeKey: ({ treeIndex }) => treeIndex,
        newNode: ({ node }) => ({
          ...node,
          ...data,
        }),
      });

      // 2️⃣ بررسی child ها و تغییر parent در صورت نیاز
      const tree2 = changeNodeAtPath({
        treeData: tree1,
        path: parentPath,
        getNodeKey: ({ treeIndex }) => treeIndex,
        newNode: ({ node }) => {
          return {
            ...node,
            isDeletable: false,
            isComposable: false,
            hasPrints: true,
          };
        },
      });

      return tree2;
    });
  };

  const refreshDataAfterReComposeAddress = (data, rowData) => {
    //
  };

  const refreshDataAfterDeComposeAddress = (data, rowData) => {
    const { path } = rowData.rowInfo;
    const parentPath = path.slice(0, -1);

    setTreeData(prevTree => {
      // 1️⃣ تغییر خود نود
      const tree1 = changeNodeAtPath({
        treeData: prevTree,
        path: path,
        getNodeKey: ({ treeIndex }) => treeIndex,
        newNode: ({ node }) => ({
          ...node,
          addressGuid: null,
          isComposable: true,
          isDeletable: true,
        }),
      });

      // اگر روت بود parent ندارد
      if (parentPath.length === 0) return tree1;

      // 2️⃣ تغییر parent فقط در صورت داشتن شرط
      const tree2 = changeNodeAtPath({
        treeData: tree1,
        path: parentPath,
        getNodeKey: ({ treeIndex }) => treeIndex,
        newNode: ({ node }) => {
          const children = node.children || [];

          const hasChildWithProperty = children.some(
            child => child.addressGuid?.length, // شرط مورد نظر
          );

          if (hasChildWithProperty) {
            return node; // parent بدون تغییر
          }

          return {
            ...node,
            hasPrints: false,
          };
        },
      });

      return tree2;
    });
  };

  const toggleNodeExpansion = expanded => {
    const newData = toggleExpandedForAll({
      treeData: treeData,
      expanded,
    });
    setTreeData(newData);
  };

  return (
    <>
      <PageSpinner loading={getLoading} />

      {!getLoading ? (
        <div className="tree-data-wrapper">
          <div className="tree-data-wrapper-insidebox">
            <TreeDataBarWrapper
              showCreateModal={() =>
                setCreateSectionNodeModal({
                  show: true,
                  guid: zoneGuid,
                })
              }
              expansionTrue={status => toggleNodeExpansion(status)}
              expansionFalse={status => toggleNodeExpansion(status)}
              goPrev={() =>
                setSearchFocusIndex(prevState =>
                  searchFocusIndex !== null
                    ? (searchFoundCount + searchFocusIndex - 1) %
                      searchFoundCount
                    : searchFoundCount - 1,
                )
              }
              searchIndex={searchFocusIndex}
              searchCount={searchFoundCount}
              goNext={() =>
                setSearchFocusIndex(prevState =>
                  searchFocusIndex !== null
                    ? (searchFocusIndex + 1) % searchFoundCount
                    : 0,
                )
              }
              searchInputChange={e => setSearchString(e.target.value)}
            />

            <TreeDataBodyWrapper
              treeData={treeData}
              changeHandler={newData => setTreeData(newData)}
              searchString={searchString}
              searchFocusIndex={searchFocusIndex}
              onlyExpandSearchedNodes
              searchFinish={matches => {
                setSearchFoundCount(matches?.length);
                const index =
                  matches?.length > 0 ? searchFocusIndex % matches?.length : 0;
                setSearchFocusIndex(index);
              }}
              editHandler={rowInfo => {
                switch (rowInfo.node.type) {
                  case 'Section':
                    setEditSectionNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      title: rowInfo.node.title,
                      rowInfo: rowInfo,
                    });
                    break;
                  case 'Area':
                    setEditAreaNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      title: rowInfo.node.title,
                      rowInfo: rowInfo,
                    });
                    break;
                  case 'Shelf':
                    setEditShelfNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      title: rowInfo.node.title,
                      rowInfo: rowInfo,
                    });
                    break;
                  case 'Part':
                    setEditPartNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      title: rowInfo.node.title,
                      rowInfo: rowInfo,
                    });
                    break;
                  case 'Cell':
                    setEditCellNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      title: rowInfo.node.title,
                      rowInfo: rowInfo,
                    });
                    break;

                  default:
                    break;
                }
              }}
              createHandler={rowInfo => {
                switch (rowInfo.node.type) {
                  case 'Section':
                    setCreateAreaNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      rowInfo: rowInfo,
                    });
                    break;
                  case 'Area':
                    setCreateShelfNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      rowInfo: rowInfo,
                    });
                    break;
                  case 'Shelf':
                    setCreatePartNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      rowInfo: rowInfo,
                    });
                    break;
                  case 'Part':
                    setCreateCellNodeModal({
                      show: true,
                      guid: rowInfo.node.guid,
                      rowInfo: rowInfo,
                    });
                    break;

                  default:
                    break;
                }
              }}
              composeHandler={rowInfo => {
                setComposeAddressModal({
                  show: true,
                  guid: rowInfo.node.guid,
                  addressGuid: rowInfo.node.addressGuid,
                  type: rowInfo.node.type,
                  rowInfo: rowInfo,
                });
              }}
              reComposeHandler={rowInfo => {
                setReComposeAddressModal({
                  show: true,
                  guid: rowInfo.node.guid,
                  addressGuid: rowInfo.node.addressGuid,
                  type: rowInfo.node.type,
                  rowInfo: rowInfo,
                });
              }}
              deComposeHandler={rowInfo => {
                setDeComposeAddressModal({
                  show: true,
                  guid: rowInfo.node.guid,
                  addressGuid: rowInfo.node.addressGuid,
                  type: rowInfo.node.type,
                  rowInfo: rowInfo,
                });
              }}
              showAddressHandler={rowInfo => {
                setShowAddressHandler({
                  show: true,
                  guid: rowInfo.node.guid,
                  addressGuid: rowInfo.node.addressGuid,
                  type: rowInfo.node.type,
                  rowInfo: rowInfo,
                });
              }}
              printHandler={rowInfo => {
                setPrintModal({
                  show: true,
                  rootPrints: rowInfo.node.hasPrints,
                  guid: rowInfo.node.guid,
                  addressGuid: rowInfo.node.addressGuid,
                  type: rowInfo.node.type,
                  rowInfo: rowInfo,
                });
              }}
              deleteHandler={rowInfo => {
                setDeleteNodeDialog({
                  show: true,
                  guid: rowInfo.node.guid,
                  nodeType: rowInfo.node.type,
                  nodeName: rowInfo.node.title,
                  rowInfo: rowInfo,
                });
              }}
            />
          </div>
        </div>
      ) : null}

      {createSectionNodeModal.show ? (
        <CreateSectionNodeModal
          show={createSectionNodeModal.show}
          closeHandler={() =>
            setCreateSectionNodeModal({ show: false, guid: null })
          }
          guid={createSectionNodeModal.guid}
          refreshData={data => {
            setCreateSectionNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterCreateNode(data, createSectionNodeModal);
          }}
        />
      ) : null}
      {editSectionNodeModal.show ? (
        <EditSectionNodeModal
          show={editSectionNodeModal.show}
          closeHandler={() =>
            setEditSectionNodeModal({ show: false, guid: null })
          }
          guid={editSectionNodeModal.guid}
          defaultName={editSectionNodeModal.title}
          refreshData={data => {
            setEditSectionNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterEditNode(data, editSectionNodeModal);
          }}
        />
      ) : null}

      {createAreaNodeModal.show ? (
        <CreateAreaNodeModal
          show={createAreaNodeModal.show}
          closeHandler={() =>
            setCreateAreaNodeModal({ show: false, guid: null })
          }
          guid={createAreaNodeModal.guid}
          refreshData={data => {
            setCreateAreaNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterCreateNode(data, createAreaNodeModal);
          }}
        />
      ) : null}
      {editAreaNodeModal.show ? (
        <EditAreaNodeModal
          show={editAreaNodeModal.show}
          closeHandler={() => setEditAreaNodeModal({ show: false, guid: null })}
          guid={editAreaNodeModal.guid}
          defaultName={editAreaNodeModal.title}
          refreshData={data => {
            setEditAreaNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterEditNode(data, editAreaNodeModal);
          }}
        />
      ) : null}

      {createShelfNodeModal.show ? (
        <CreateShelfNodeModal
          show={createShelfNodeModal.show}
          closeHandler={() =>
            setCreateShelfNodeModal({ show: false, guid: null })
          }
          guid={createShelfNodeModal.guid}
          refreshData={data => {
            setCreateShelfNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterCreateNode(data, createShelfNodeModal);
          }}
        />
      ) : null}
      {editShelfNodeModal.show ? (
        <EditShelfNodeModal
          show={editShelfNodeModal.show}
          closeHandler={() =>
            setEditShelfNodeModal({ show: false, guid: null })
          }
          guid={editShelfNodeModal.guid}
          defaultName={editShelfNodeModal.title}
          refreshData={data => {
            setEditShelfNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterEditNode(data, editShelfNodeModal);
          }}
        />
      ) : null}

      {createPartNodeModal.show ? (
        <CreatePartNodeModal
          show={createPartNodeModal.show}
          closeHandler={() =>
            setCreatePartNodeModal({ show: false, guid: null })
          }
          guid={createPartNodeModal.guid}
          refreshData={data => {
            setCreatePartNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterCreateNode(data, createPartNodeModal);
          }}
        />
      ) : null}
      {editPartNodeModal.show ? (
        <EditPartNodeModal
          show={editPartNodeModal.show}
          closeHandler={() => setEditPartNodeModal({ show: false, guid: null })}
          guid={editPartNodeModal.guid}
          defaultName={editPartNodeModal.title}
          refreshData={data => {
            setEditPartNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterEditNode(data, editPartNodeModal);
          }}
        />
      ) : null}

      {createCellNodeModal.show ? (
        <CreateCellNodeModal
          show={createCellNodeModal.show}
          closeHandler={() =>
            setCreateCellNodeModal({ show: false, guid: null })
          }
          guid={createCellNodeModal.guid}
          refreshData={data => {
            setCreateCellNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterCreateNode(data, createCellNodeModal);
          }}
        />
      ) : null}
      {editCellNodeModal.show ? (
        <EditCellNodeModal
          show={editCellNodeModal.show}
          closeHandler={() => setEditCellNodeModal({ show: false, guid: null })}
          guid={editCellNodeModal.guid}
          defaultName={editCellNodeModal.title}
          refreshData={data => {
            setEditCellNodeModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterEditNode(data, editCellNodeModal);
          }}
        />
      ) : null}

      {composeAddressModal.show ? (
        <ComposeAddressModal
          show={composeAddressModal.show}
          closeHandler={() =>
            setComposeAddressModal({ show: false, guid: null })
          }
          guid={composeAddressModal.guid}
          type={composeAddressModal.type}
          defaultName={composeAddressModal.title}
          refreshData={data => {
            setComposeAddressModal({
              show: false,
              guid: null,
              type: '',
            });
            refreshDataAfterComposeAddress(data, composeAddressModal);
          }}
        />
      ) : null}
      {reComposeAddressModal.show ? (
        <RecomposeAddressModal
          show={reComposeAddressModal.show}
          closeHandler={() =>
            setReComposeAddressModal({
              show: false,
              guid: null,
              addressGuid: null,
            })
          }
          guid={reComposeAddressModal.guid}
          addressGuid={reComposeAddressModal.addressGuid}
          refreshData={data => {
            setReComposeAddressModal({
              show: false,
              guid: null,
              addressGuid: null,
              type: '',
            });
            refreshDataAfterReComposeAddress(data, reComposeAddressModal);
          }}
        />
      ) : null}
      {deComposeAddressModal.show ? (
        <DeComposeAddressModal
          show={deComposeAddressModal.show}
          closeHandler={() =>
            setDeComposeAddressModal({
              show: false,
              guid: null,
              addressGuid: null,
            })
          }
          guid={deComposeAddressModal.guid}
          addressGuid={deComposeAddressModal.addressGuid}
          refreshData={data => {
            setDeComposeAddressModal({
              show: false,
              guid: null,
              addressGuid: null,
              type: '',
            });
            refreshDataAfterDeComposeAddress(data, deComposeAddressModal);
          }}
        />
      ) : null}
      {showAddressHandler.show ? (
        <ShowAddressModal
          show={showAddressHandler.show}
          closeHandler={() =>
            setShowAddressHandler({
              show: false,
              guid: null,
              addressGuid: null,
            })
          }
          guid={showAddressHandler.guid}
          addressGuid={showAddressHandler.addressGuid}
        />
      ) : null}

      {deleteNodeDialog ? (
        <DeleteNodeDialog
          show={deleteNodeDialog.show}
          nodeType={deleteNodeDialog.nodeType}
          nodeName={deleteNodeDialog.nodeName}
          closeHandler={() => setDeleteNodeDialog({ show: false, guid: null })}
          guid={deleteNodeDialog.guid}
          refreshData={() => {
            setDeleteNodeDialog({
              show: false,
              guid: '',
            });
            refreshDataAfterDeleteNode(deleteNodeDialog);
          }}
        />
      ) : null}

      <PrintModal
        show={printModal.show}
        handleClose={() =>
          setPrintModal(prev => ({
            show: false,
            rootPrints: false,
            guid: null,
            addressGuid: null,
            type: null,
          }))
        }
        rootPrints={printModal.rootPrints}
        guid={printModal.guid}
        addressGuid={printModal.addressGuid}
        type={printModal.type}
      />
    </>
  );
}

export default LocationsCategories;
